import type { SuggestedAppTile_m365App$key } from "./__generated__/SuggestedAppTile_m365App.types.graphql";
import { graphql } from "./taggedNode";
/**
 *
 * @interface SuggestedAppTileProps
 */
export interface SuggestedAppTileProps {
  /**
   * The underlying data for the app that the App Card represents.
   *
   * @type {SuggestedAppTile_m365App$key}
   * @memberof SuggestedAppTileProps
   */
  m365App: SuggestedAppTile_m365App$key; // Generated opaque key for the generated typing for the SuggestedAppTile_m365App fragment
  privacyLabel: string;
  termsOfUseLabel: string;
  permissionsLabel: string;
  addLabel: string;
  /**
   * Callback executed after tile is clicked or Action button is clicked
   */
  onClicked?(): void;
}
// The GraphQL fragment representing the LaunchTile data
export const dataFragment = graphql`
  fragment SuggestedAppTile_m365App on M365Application {
    id
    platformType
    name
    accessibleName
    icon {
      __typename
      ... on InternalIcon {
        name
      }
      ... on RemoteImage {
        src
        isFullBleed
      }
    }
    selectedStateIconOverride {
      __typename
      ... on InternalIcon {
        name
      }
      ... on RemoteImage {
        src
        isFullBleed
      }
    }
    ... on M365PlatformApplication {
      shortDescription
      privacyUrl
      termsOfUseUrl
      hasPermissions
      canBeAcquired
    }
  }
`;
